import { apiClient } from './client'
import { Density, Flavor, ModePreference } from '../theme/signatureTokens'

/** Preferências de aparência persistidas por usuário + empresa (EmpresaUsuario.preferencias.ui). */
export interface UiPreferences {
  flavor: Flavor
  modePref: ModePreference
  density: Density
  locale: string
}

export const appearanceApi = {
  get: async (empresaId: number, modulo = 'galatea') => {
    const { data } = await apiClient.get('/ui/appearance', {
      params: { empresa_id: empresaId, modulo },
    })
    return data as { brand: Record<string, unknown>; ui: Partial<UiPreferences> & Record<string, unknown> }
  },
  savePreferences: async (empresaId: number, ui: UiPreferences) => {
    const { data } = await apiClient.put('/ui/preferences', { id_empresa: empresaId, ui })
    return data as { ok: boolean }
  },
}
